import styled from 'styled-components/macro';
import css from '@styled-system/css';
import { themeGet } from '@styled-system/theme-get';

export const StyledPercentWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  align-items: center;
  justify-content: center;

  &.is--disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: ${themeGet('radii.small')};
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.input.regular')};
`;

export const StyledButton = styled.button(
  () =>
    css({
      backgroundColor: 'white',
      color: 'primary.extra',
      fontWeight: 'semi',
      fontSize: 'base',
      lineHeight: '1.5',

      '&:not(:last-child)': {
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        borderRightColor: 'input.regular'
      },

      '&.active': {
        backgroundColor: 'input.regular'
      }
    }),
  {
    padding: '10px 20px',
    borderRadius: 0,
    flexGrow: 1
  }
);
